export { AlertComponent } from './alert.component';
export { AlertModule } from './alert.module';
export { AlertConfig } from './alert.config';



// WEBPACK FOOTER //
// ./.tmp/alert/index.ts